<div class="simple-card">
  <div class="form-group">
    <form [formGroup]="deliveryCostForm" (submit)="submit()">
      <label class="cx-delivery-cost-title" for="zipCode">
        {{ 'deliveryCost.title' | cxTranslate }}
        <abbr *cxFeature="'a11yRequiredAsterisks'" class="text-decoration-none" title="{{ 'common.required' | cxTranslate }}">*</abbr>
      </label>

      <div class="cx-delivery-cost-container">
        <div class="box-input">
          <input
            formControlName="zipCode"
            class="form-control input-coupon-code"
            [mask]="'00000-000'"
            required="true"
            type="text"
            placeholder="{{ 'deliveryCost.input.placeholder' | cxTranslate }}"
            [attr.aria-label]="'deliveryCost.title' | cxTranslate"
          />

          <button class="btn btn-block btn-sm btn-primary apply-coupon-button" type="submit">
            {{ 'deliveryCost.submit' | cxTranslate }}
          </button>
        </div>

        <cx-form-errors [control]="deliveryCostForm.get('zipCode')"></cx-form-errors>
      </div>
    </form>
  </div>

  <ng-container
    *ngIf="{
      deliveryCost: deliveryCost$ | async,
      isLoading: isLoading$ | async,
    } as content"
  >
    @if (!content.isLoading) {
      <div *ngIf="content.deliveryCost" class="delivery-cost-content">
        <p class="address">
          {{ content.deliveryCost?.address }}
        </p>

        <div class="box-total">
          <span class="label">
            {{ 'deliveryCost.content.total' | cxTranslate }}
          </span>

          <span class="amount">
            {{ content.deliveryCost?.totalValue }}
          </span>
        </div>
      </div>
    } @else {
      <local-loader class="m-tb-20"></local-loader>
    }
  </ng-container>
</div>
